/*
  Ingredient card flip — GB. New code (this file only). Deferred, no dependencies.
  Paired with the flip block in component-ingredient-card.css.

  Event delegation rather than a custom element, deliberately: the card is a snippet
  that other sections will render, and delegation means a card injected later (theme
  editor re-render, Section Rendering API) works with no re-initialisation.

  What it handles beyond the obvious toggle:

  - FOCUS. Opening moves focus to the Back button, so a keyboard user lands on the
    face that just appeared instead of being stranded on a control that rotated away.
    Closing returns focus to the button that opened it.
  - ESCAPE closes, matching every other dismissible surface in the theme.
  - ARIA. aria-expanded tracks state on the opening button; the hidden face is marked
    aria-hidden as well as being pulled from the tab order by CSS visibility.
  - CAROUSEL. A flipped card must not rotate away mid-read, so opening dispatches a
    bubbling gb:card:flip-open that <fade-carousel> holds on, and closing releases it.
    Events rather than direct calls, so neither component has to know the other exists.
*/
(function () {
  var FLIPPED = 'ingredient-card--flipped';

  function faces(card) {
    return {
      front: card.querySelector('.ingredient-card__face--front'),
      back: card.querySelector('.ingredient-card__face--back'),
      opener: card.querySelector('[data-ingredient-flip="open"]'),
      closer: card.querySelector('[data-ingredient-flip="close"]'),
    };
  }

  function setState(card, open) {
    var el = faces(card);
    card.classList.toggle(FLIPPED, open);

    if (el.opener) el.opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (el.front) el.front.setAttribute('aria-hidden', open ? 'true' : 'false');
    if (el.back) el.back.setAttribute('aria-hidden', open ? 'false' : 'true');

    // Hold the carousel while any card is showing its back.
    card.dispatchEvent(
      new CustomEvent(open ? 'gb:card:flip-open' : 'gb:card:flip-close', { bubbles: true })
    );

    // Move focus to the face that is now facing the visitor.
    var target = open ? el.closer : el.opener;
    if (target) {
      // After the rotation, otherwise focus lands on a face still turning.
      window.setTimeout(function () {
        if (card.classList.contains(FLIPPED) === open) target.focus();
      }, 50);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ingredient-flip]');
    if (!trigger) return;

    var card = trigger.closest('.ingredient-card--flippable');
    if (!card) return;

    event.preventDefault();
    setState(card, trigger.dataset.ingredientFlip === 'open');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var card = event.target.closest('.ingredient-card--flippable.' + FLIPPED);
    if (!card) return;
    setState(card, false);
  });

  // Reset every flipped card when the section re-renders in the theme editor,
  // so a merchant never lands on a card stuck showing its back.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.' + FLIPPED).forEach(function (card) {
      setState(card, false);
    });
  });
})();
